export const CONTACT_EMAIL = 'hello@work-better.com';
export const FIRM_NOT_ACTIVE_ERROR = 'FIRM_NOT_ACTIVE';
export const PLACEHOLDER_IMAGE = '/placeholder.png';